<template>
  <div ref="tableRenderWrap" class="wrap">
    <complete-table ref="table">
      <!-- 注意这里的slot值要和tableOptions中配置的slotName一致 -->
      <!-- #operator是简写，详细请查阅vue文档 -->
      <template #operator> </template>
    </complete-table>
  </div>
</template>

<script>
import { generalRequest } from "@/CommonDP/utils";
import {
  getListConfigJSON,
  requestFormJson,
  exportExcel,
  requestBatchDel,
  dynamicPageList,
  getDownloadDesignTemplateInfo,
  requestBatchDelByVformWidget
} from "@/CommonDP/service/listFlow-service";
import metadataService from "@/CommonDP/service/metadata-service";
import { checkPermission } from "@/CommonDP/utils/routeAuth";
import { mapActions, mapState } from "vuex";
import flowService from "@/CommonDP/service/flow-service";
import { componentList } from "@/CommonDP/exportComponentList";
import importFileComp from "@/CommonDP/pages/mainMg/lowcode/tableSettings/uploaderExcel/index.vue";
import importRefreshComp from "@/CommonDP/pages/mainMg/lowcode/tableSettings/updateExcel/index.vue";
import { openFlow } from "@/CommonDP/components/processComponents/flowNew/index.js";
import { downloadFileShowPrompt, decodeFileName } from "@/CommonDP/utils";
import request from "@/CommonDP/utils/request";
import Sortable from "sortablejs";
export default {
  // eslint-disable-next-line
  name: "tableRender",
  props: {
    externalParams: {
      type: Object,
      default: () => {
        return {};
      }
    },
    notNeedQueryTableData: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    previewMode: Boolean,
    relateId: {
      type: String,
      default: ""
    },
    rawRelateId: {
      type: String,
      default: ""
    },
    options: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      wrapHeight: {
        height: ""
      }
    };
  },

  computed: {
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    })
  },

  provide() {
    return {
      importRefreshComp,
      importFileComp,
      openFlow,
      componentList,
      generalRequest,
      Sortable,
      request,
      checkPermission,
      requestTableData: this.requestTableData,
      requestTreeData: this.requestTreeData,
      requestTablePaginationData: this.requestTablePaginationData,
      requestTableConfig: this.requestTableConfig,
      requestDownload: this.requestDownload,
      requestBatchFlowDoc: this.requestBatchFlowDoc,
      requestBatchDel: this.requestBatchDel,
      requestBatchDelByVformWidget: this.requestBatchDelByVformWidget,
      queryFlowDef: flowService.queryFlowDef,
      enterpriseId: this.enterpriseId,
      getPrjInfo: () => this.prjInfo,
      userInfo: this.userInfo,
      updatePrj: this.updatePrj,
      queryChangePrjId: this.queryChangePrjId,
      getListPageId: () => this.relateId,
      getRawRelateId: () => this.rawRelateId,
      getWrapHeight: () => this.wrapHeight
    };
  },

  watch: {
    rawRelateId: {
      handler(val) {
        console.log(val, "rawRelateId");
        if (val && this.$refs.table) {
          this.$refs.table.init(this.previewMode, this.options, this.externalParams, this.notNeedQueryTableData);
        } else if (val && !this.$refs.table) {
          this.$nextTick(() => this.$refs.table.init(this.previewMode, this.options, this.externalParams, this.notNeedQueryTableData));
        }
      },
      immediate: true
    }
  },

  mounted() {
    try {
      this.wrapHeight.height = parseFloat(window.getComputedStyle(this.$refs.tableRenderWrap).height);
    } catch (error) {
      console.error("获取低代码table渲染wrapDom高度报错，报错信息：", error);
    }
  },

  methods: {
    ...mapActions(["updatePrj"]),
    expose_showDialog() {
      this.dialogVisible = true;
    },

    expose_setTableData(tableData) {
      if (tableData && this.$refs.table) {
        this.$refs.table.expose_setTableData(tableData);
      } else if (tableData && !this.$refs.table) {
        this.$nextTick(() => this.$refs.table.expose_setTableData(tableData));
      }
    },

    handleClose() {
      this.dialogVisible = false;
    },

    requestDownload(params, listPageId) {
      console.log(params);
      return exportExcel(params, listPageId);
    },
    async requestBatchFlowDoc(command, keys) {
      keys.map((val) => {
        if (command === "down") {
          this.flowDown(val);
        } else if (command === "recreate") {
          this.recreateFlowDown(val);
        }
      });
    },
    async recreateFlowDown(key) {
      await this.$confirm(`确认重新生成成果文件吗？`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      this.$success("生成中请稍候，完成后将自动下载成果文件");
      await flowService.recreateDesignFile("", key);
      this.flowDown(key);
    },
    requestBatchDel(primaryKeyValueList, ID) {
      return this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        return requestBatchDel(primaryKeyValueList, ID);
      });
    },
    requestBatchDelByVformWidget(ID, primaryKeyValueList) {
      return this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        console.log("asdasd");

        return requestBatchDelByVformWidget(ID, primaryKeyValueList);
      });
    },
    requestFormJson,
    confirm() {
      this.$emit("refreshList");
    },
    refreshData(data) {
      console.log(data);
      let params;
      if (Object.prototype.toString(data) === "[object Object]") {
        params = data;
      } else {
        params = {
          pageParams: data
        };
      }
      this.$refs.table.refreshData(params);
    },
    onSave(row) {
      // 推出编辑清空状态
      row.$edit = false;
      this.$refs.table.expose_clearCurCellPro();
    },
    selectListHandler(val) {
      console.log(val);
    },

    requestTableData(params = {}, id) {
      const { tabId, ...otherParams } = params;
      return metadataService.dynamicList(otherParams, id, tabId);
    },

    requestTreeData(params = {}, id) {
      return metadataService.dynamicTreeData(params, id).then((res) => {
        // res.data = res.data.slice(0, 40);
        return res;
      });
    },

    requestTablePaginationData(params = {}, page, id) {
      const { tabId, ...otherParams } = params;
      page = {
        ...page,
        tabId
      };
      return dynamicPageList(otherParams, page, id);
    },

    requestTableConfig(id) {
      return getListConfigJSON(id);
    },

    async flowDown(id) {
      const response = await getDownloadDesignTemplateInfo("", id);
      const fileName = decodeFileName(response.getHeaders()["content-disposition"]);
      downloadFileShowPrompt(fileName, response);
    },
    async queryChangePrjId(listPageId, id) {
      const response = await metadataService.getCurrentDataPrjId(listPageId, id);
      return response.data;
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.wrap {
  height: 100%;
  /deep/ .el-table--border .el-table__cell:first-child .cell {
    padding-left: 5px;
  }
  /deep/  .el-table th.el-table__cell > .cell {
    padding-right: 5px
  }
}

::v-deep .CompleteTable{
  padding: var(--big-space) var(--big-space) 0;
  .el-header{
    margin-top: 0 !important;
    padding: 0;
  }
  .el-row{
    margin-left: 0 !important;
    padding: 0 !important;
    .el-button{
      margin-right: var(--small-space) !important;
    }
  }
  .el-main{
    padding: var(--middle-space) 0 0;
  }
  .main-padding{
    padding: 0 !important;
  }
  .baseRenderTableMidd{
    padding: 0;
    display: flex;
    flex-direction: column;
  }
  .el-footer{
    height: 54px !important;
    padding: 0;
    display: flex;
    align-items: center;
    flex-direction: row-reverse;
  }
}
</style>
